import {
  Button,
  Card,
  CardContent,
  CardHeader,
  Dialog,
  IconButton,
  Typography,
} from "@mui/material";
import React, { Fragment, useRef, useState } from "react";
import bg2 from "../../images/bg2.png";
import { Close } from "@mui/icons-material";
import { Badge, ConfigProvider, Table } from "antd";
import ApexCharts from "apexcharts";
import { notiError } from "../../utils/notiUltils";
import dayjs from "dayjs";

function groupDataByHour(data) {
  const groupedData = {};

  data.forEach((item) => {
    const hour =
      dayjs(item.GpsDatetime).utc().format("HH:mm:ss").split(":")[0] + ":00";
    if (!groupedData[hour]) {
      groupedData[hour] = 0;
    }
    groupedData[hour]++;
  });

  return groupedData;
}

function ShowEvent({ disabled = false, api }) {
  const refChart = useRef(null);
  const [open, setOpen] = useState(false);
  const [dataSource, setDataSource] = useState([]);

  const handleClickOpen = () => {
    setOpen(true);
    if (refChart.current) {
      refChart.current.destroy();
    }

    api
      .post("/eventData", null, localStorage.getItem("token"))
      .then((data) => {
        const category1 = [...data].filter((a) => a.CategoryID === 0);
        const result1 = groupDataByHour(category1);
        const keysCategory1 = Object.keys(result1).reverse();
        const valuesCategory1 = Object.values(result1).reverse();
        const category2 = [...data].filter((a) => a.CategoryID === 1);
        const result2 = groupDataByHour(category2);
        const keysCategory2 = Object.keys(result2).reverse();
        const valuesCategory2 = Object.values(result2).reverse();
        const category3 = [...data].filter((a) => a.CategoryID === 2);
        const result3 = groupDataByHour(category3);
        const keysCategory3 = Object.keys(result3).reverse();
        const valuesCategory3 = Object.values(result3).reverse();

        const series = [
          { name: "เขตชุมชน", data: valuesCategory1 },
          { name: "จำกัดความเร็ว", data: valuesCategory2 },
          { name: "พื้นที่เสี่ยง", data: valuesCategory3 },
        ];
        let categories =
          keysCategory1.length > keysCategory2.length
            ? keysCategory1
            : keysCategory2;
        categories =
          categories.length > keysCategory3.length ? categories : keysCategory3;

        data.forEach((a, k) => (a.key = k));
        const options = {
          chart: {
            type: "bar",
            stacked: true,
            toolbar: {
              export: {
                svg: {
                  filename: `event_${dayjs().format("YYYY-MM-DD HH-mm-ss")}`,
                },
                png: {
                  filename: `event_${dayjs().format("YYYY-MM-DD HH-mm-ss")}`,
                },
              },
            },
          },
          dataLabels: {
            enabled: false,
          },
          series,
          xaxis: {
            categories,
          },
          grid: {
            show: true,
            borderColor: "#90A4AE88",
            strokeDashArray: 5,
          },
          /*plotOptions: {
            bar: {
              borderRadius: 4,             
            },
          },*/
        };
        const chart = new ApexCharts(
          document.querySelector("#chart_03"),
          options
        );
        chart.render();
        refChart.current = chart;
        setDataSource(data);
      })
      .catch((error) => {
        console.error(error);
        notiError({ message: error, position: "center" });
      });
  };

  const handleClose = () => {
    if (refChart.current) {
      refChart.current.destroy();
    }
    setOpen(false);
    setDataSource([]);
  };

  return (
    <Fragment>
      <Button
        disabled={disabled}
        //color="info"
        sx={{ textTransform: "none" }}
        onClick={handleClickOpen}
      >
        แสดงทั้งหมด
      </Button>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        maxWidth={"md"}
        scroll="body"
      >
        <Card
          sx={{
            backgroundImage: `url(${bg2})`,
            backgroundPosition: "center",
            backgroundSize: "cover",
            backgroundColor: "#b4a0ff",
            backgroundRepeat: "no-repeat",
            p: 5,
          }}
        >
          <CardHeader
            className="animate__animated animate__lightSpeedInRight"
            title={"รายการเหตุการณ์ที่เกิดขึ้นประจำวัน"}
            titleTypographyProps={{ variant: "h6", component: "h2" }}
            subheader={"แสดงเหตุการณ์ที่เกิดขึ้นเมื่อมีรถอยู่ในตำแหน่งพื้นที่"}
            subheaderTypographyProps={{ variant: "caption" }}
            action={
              <IconButton onClick={handleClose}>
                <Close />
              </IconButton>
            }
          />

          <CardContent>
            <Badge.Ribbon text="กราฟรายชั่วโมง" placement="start">
              <Card
                elevation={24}
                className="animate__animated animate__backInUp"
                sx={{ width: "100%", pt: 1 }}
              >
                <CardContent>
                  <div id="chart_03"></div>
                  <TableData dataSource={dataSource} />
                </CardContent>
              </Card>
            </Badge.Ribbon>
          </CardContent>
        </Card>
      </Dialog>
    </Fragment>
  );
}

export default ShowEvent;

function TableData({ dataSource }) {
  return (
    <ConfigProvider
      theme={{
        token: {
          fontFamily: "kanit",
          colorBgContainer: "transparent",
        },
      }}
    >
      <Table
        columns={[
          {
            title: "วัน-เวลา",
            render: (a) => (
              <Typography variant="body2" fontWeight={300}>
                {dayjs(a.GpsDatetime).utc().format("YYYY-MM-DD HH:mm:ss")}
              </Typography>
            ),
          },
          {
            title: "ทะเบียน",
            render: (a) => (
              <Typography variant="body2" fontWeight={300}>
                {a.VehicleName}
              </Typography>
            ),
          },
          {
            title: "ชื่อสถานที่",
            render: (a) => (
              <Typography variant="body2" fontWeight={300}>
                {a.LocationName}
              </Typography>
            ),
          },
          {
            title: "หมวดหมู่",
            render: (a) => (
              <Typography variant="body2" fontWeight={300}>
                {a.CategoryName}
              </Typography>
            ),
          },
        ]}
        dataSource={dataSource}
        bordered
        //size="small"
        pagination={{ showSizeChanger: false, position: ["bottomCenter"] }}
      />
    </ConfigProvider>
  );
}
